import DetailedTurnoutInspectionForm from "../Timps/Ontario/DetailedTurnoutInspectionForm";
import DetailedTurnoutInspectionFormNew from "../Timps/Ontario/DetailedTurnoutInspectionFormNew";

import SignalStorageBattery from "../sims/ontario/signalStorageBattery";
import ETRSignalStorageBattery from "../sims/ontario/etrSignalStorageBattery";
import { NOPB_SwitchInspectionReportView, NOPB_SwitchInspectionReportViewV1 } from "../NOPB/SwitchInspectionReport";
import { TNW_SwitchInspectionReportView, TNW_SwitchInspectionReportViewV1 } from "../TNW/SwitchInspectionReport";
import LoadMeterReport from "../ReVAMP/Periodic/LoadMeter";
import CLMBLoadMeterReport from "../ReVAMP/Periodic/LoadMeter/CLMB";
import Periodic92And184DaysReport from "../ReVAMP/Periodic/92And184Days";
import CLMB_Periodic92And184DaysReport from "../ReVAMP/Periodic/92And184Days/CLMB";
import AirBrakeReport_A from "../ReVAMP/AirBrakeReports/AirBrakeReports/AirBrakeReport_A";
import CLMB_AirBrakeLvlOne from "../ReVAMP/AirBrakeReports/AirBrakeReports/CLMB/AirBrakeReportLevelOne";
import AirBrakeReport_C from "../ReVAMP/AirBrakeReports/AirBrakeReports/AirBrakeReport_C";
import CLMB_AirBrakeReportSys4lvl3 from "../ReVAMP/AirBrakeReports/AirBrakeReports/CLMB/AirBrakeReportSys4Lvl3";
import JobBriefingTIMPSschema from "../../jobBriefing/JobBrieifingReport/Ontario/ONR_JobBriefingTIMPS/JobBriefingTIMPSschema";
import JobBriefingTIMPSschemaV1 from "../../jobBriefing/JobBrieifingReport/Ontario/ONR_JobBriefingTIMPS/JobBriefingTIMPSschemaV1";
import JobBriefingSITEschema from "../../jobBriefing/JobBrieifingReport/Ontario/ONR_JobBriefingSITE/JobBriefingSITEschema";
import JobBriefingSITEschemaV1 from "../../jobBriefing/JobBrieifingReport/Ontario/ONR_JobBriefingSITE/JobBriefingSITEschemaV1";
import detailedTurnoutInspectionReportView from "../Timps/EtrSwitchReport/detailedTurnoutInspectionReportView";
import detailedTurnoutInspectionReportViewV2 from "../Timps/EtrSwitchReport/detailedTurnoutInspectionReportViewV2";

export default function reportByVersion(ver, code) {
  const version = {
    /**
     * ONRDetailedTurnoutReport
     * @property {String} default - Default report version.
     * @property {String} v1_0 - Version 1.0, Wednesday, October 18, 2023 11:53 AM.
     */

    onrTurnoutForm: {
      default: DetailedTurnoutInspectionForm,
      "1.0": DetailedTurnoutInspectionFormNew,
    },
    batteryCardVariation: {
      default: SignalStorageBattery,
      ETRBatteryCard: ETRSignalStorageBattery,
    },

    etrLHandRHturnoutInspectionReport: {
      default: detailedTurnoutInspectionReportView,
      "1.0": detailedTurnoutInspectionReportViewV2,
    },

    nopbSwitchInspectionReport: {
      default: NOPB_SwitchInspectionReportView,
      "1.0": NOPB_SwitchInspectionReportViewV1, // 4/15/2025
    },

    tnwSwitchInspectionReport: {
      default: TNW_SwitchInspectionReportView,
      "1.0": TNW_SwitchInspectionReportViewV1, // 4/15/2025
    },
    periodic368Days: {
      default: LoadMeterReport,
      CLMB_Loadmeter368days: CLMBLoadMeterReport,
    },
    periodic92Days: {
      default: Periodic92And184DaysReport,
      CLMB_Columbia92DaysVariationMethod: CLMB_Periodic92And184DaysReport,
    },
    AirBrakeAFMLevelOne: {
      default: AirBrakeReport_A,
      CLMB_AirBrakeLevelOne: CLMB_AirBrakeLvlOne,
    },
    AirBrakeSys4Lvl3: {
      default: AirBrakeReport_C,
      CLMB_AirBrakeSys4Lvl3: CLMB_AirBrakeReportSys4lvl3,
    },
    onrTIMPSJobBriefing: {
      default: JobBriefingTIMPSschema,
      "1.0": JobBriefingTIMPSschemaV1,
    },
    onrSITEJobBriefing: {
      default: JobBriefingSITEschema,
      "1.0": JobBriefingSITEschemaV1,
    },
  };

  return version[code][ver] || version[code].default;
}



// WEBPACK FOOTER //
// ./src/components/Reports/utils/reportVersions.js